import { memo } from "react";
import Button from "@mui/material/Button";
import useUploadSettlementContext from "./useUploadSettlementContext";

const UploadSettlement = () => {
    const { onOpen } = useUploadSettlementContext();

    return (
        <Button
            variant='soft'
            onClick={onOpen}
        >
            Upload Settlement
        </Button>
    );
};

export default memo(UploadSettlement);
